import { useState } from "react";

import { Box, Badge, Button, Dialog } from "@mui/material";

import { useBoolean } from "src/hooks/use-boolean";

import { useTranslate } from "src/locales";

import { CompaniesTable } from "./companies-table";

const CompanySwitcher = () => {

  const { t } = useTranslate('common');
  const dialog = useBoolean(false);
  const [notificationCount, setNotificationCount] = useState(0);

  return (
    <>
      <Badge color="warning" overlap="circular" badgeContent={notificationCount} invisible={notificationCount === 0}>
        <Button
          variant='outlined'
          color='primary'
          onClick={dialog.onTrue}
          sx={{ mr: 2 }}
        >
          {t('companies')}
        </Button>
      </Badge>
      <Dialog open={dialog.value} onClose={dialog.onFalse} fullWidth maxWidth="lg">
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', height: 'calc(100vh)' }}>
          <CompaniesTable isDialog setNotificationCount={setNotificationCount} />
        </Box>
      </Dialog >
    </>
  )
}

export default CompanySwitcher;